// @ts-ignore
import EventEmitter from 'events' // eslint-disable-line

const dispatcher = new EventEmitter.EventEmitter()

export default dispatcher
